import { call, delay } from 'redux-saga/effects';
import { ApiRequestConfig } from '../index';

export function* expRetry<Data>(
  apiMethod: (...args: any[]) => any,
  url: string,
  data: Data,
  config?: ApiRequestConfig,
  maxTries = 3
): Generator {
  for (let i = 0; i < maxTries; i += 1) {
    try {
      return yield call(apiMethod, url, data, config);
    } catch (err) {
      if (i < maxTries - 1) {
        let exponentialDelay = Math.floor(Math.random() * 3 + 3 * i + 1) * 100;
        yield delay(exponentialDelay);
      }
    }
  }

  throw new Error(`Request failed after ${maxTries} tries`);
}
